import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import styles from './NotificationItem.module.scss';
import { NotificationItemProps } from './NotificationCenter.types';
import { NOTIFICATION_CATEGORY, NOTIFICATION_CATEGORY_LABEL, NOTIFICATION_VERB } from './NotificationCenter.constants';
import { getInitialsFromName, openCompanyDealsInNewTab, openUserPortfolioInNewTab } from '../../utils/utils';
import DoneAllIcon from '../../assets/Svg/DoneAllIcon';

dayjs.extend(relativeTime);

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, onItemAction, onMarkRead }) => {
    const { id, actorName, companyName, lenderName, comment, orgId, companyAccessType, isRead, isMention, createdAt, category } =
        notification;

    const verb = isMention ? NOTIFICATION_VERB.MENTIONED : NOTIFICATION_VERB.ADDED;
    const isDeal = category === NOTIFICATION_CATEGORY.DEAL;
    const categoryLabel = isDeal ? NOTIFICATION_CATEGORY_LABEL.DEAL : NOTIFICATION_CATEGORY_LABEL.LEAD;

    const handleCompanyClick = () => {
        if (isDeal) {
            openCompanyDealsInNewTab(orgId);
        } else {
            openUserPortfolioInNewTab(orgId, companyAccessType || '');
        }
        onItemAction(notification);
    };

    const handleMarkRead = (e: React.MouseEvent) => {
        e.stopPropagation();
        onMarkRead(id);
    };

    return (
        <div className={`${styles.NotificationItem} ${!isRead ? styles.Unread : ''}`}>
            <div className={styles.Avatar}>{getInitialsFromName(actorName)}</div>
            <div className={styles.Content}>
                <p className={styles.Header}>
                    <strong>{actorName}</strong>
                    {` ${verb} on ${categoryLabel}`}
                </p>
                {companyName && (
                    <button type="button" className={styles.CompanyLine} onClick={handleCompanyClick}>
                        <span className={styles.CompanyLink}>{companyName}</span>
                        {isDeal && lenderName && <span className={styles.LenderSuffix}>{` <> ${lenderName}`}</span>}
                    </button>
                )}
                {comment && <div className={styles.CommentBox} dangerouslySetInnerHTML={{ __html: comment }} />}
                <div className={styles.Footer}>
                    <span className={styles.Timestamp}>{dayjs(createdAt).fromNow()}</span>
                </div>
            </div>
            {!isRead && (
                <button type="button" className={styles.MarkReadBtn} onClick={handleMarkRead}>
                    <DoneAllIcon color="currentColor" />
                    Mark read
                </button>
            )}
        </div>
    );
};

export default NotificationItem;
